import React from 'react';
import { FontIcon } from 'react-toolbox';
import { getPhaseMarginProfit } from '../../../selectors/phase';
import goldMedal from 'images/gold-medal.png';
import silverMedal from 'images/silver-medal.png';
import bronzeMedal from 'images/bronze-medal.png';
import S from './styles.scss';
import PhaseType from 'types/phase';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/core';

const pulse = keyframes`
0% {
  transform: scale(1);
}
50% {
  transform: scale(1.05);
}
100% {
  transform: scale(1);
}
`;

const LowMarginDiv = styled.div(() => ({
  animation: `${pulse} 2500ms infinite`,
}));

const determineStatusMedal = (phase, margin) => {
  const { mid_margin = 0, high_margin = 0 } = phase;
  let src = goldMedal;
  if (margin < mid_margin) src = bronzeMedal;
  else if (margin < high_margin) src = silverMedal;
  return (<img className={S.medalImg} alt="Service Pros logo" src={src} />);
};

const ProfitMargin = ({ phase, phase: { low_margin = 0 } }) => {
  const { margin } = getPhaseMarginProfit(phase);
  return (<div className={S.wrapper}>
    {(margin < low_margin || low_margin === 0) ? (<LowMarginDiv>
      <span className={S.content} >
        <FontIcon value="attach_money" />
        Low Margin
      </span>
    </LowMarginDiv>) : (<div className={S.contentWrapper}>
      {determineStatusMedal(phase, margin)}
    </div>)}
  </div>);
};

ProfitMargin.propTypes = { phase: PhaseType.isRequired };

export default ProfitMargin;



// WEBPACK FOOTER //
// ./client/app/shared/components/ProfitMargin/index.jsx